import React, { ReactElement } from 'react'

import Price from '../shared/Price'

interface Props {
  currency: string
  description: string
  endToEndDescrAttr: string
  endToEndPriceAttr: string
  hideOfferPrice?: boolean
  offerPrice?: number
  price: number
}

const PriceItem: React.FC<Props> = ({
  currency,
  description,
  endToEndDescrAttr,
  endToEndPriceAttr,
  hideOfferPrice,
  offerPrice,
  price,
}): ReactElement => {
  return (
    <div className="flex h-fit items-end justify-between gap-2">
      <span className="typography-body-md-regular text-semantic-global-text-default text-left" data-e2e={endToEndDescrAttr}>
        {description}
      </span>
      {offerPrice != undefined ? (
        <div className="gap-primitive-4 flex flex-row items-center">
          {!hideOfferPrice ? (
            <div className="typography-body-sm-regular text-dfds-text-dark-secondary line-through" data-e2e="line-through-price">
              <Price currency={currency} dataAttr={endToEndPriceAttr} price={price} />
            </div>
          ) : null}
          <div className="typography-body-md-regular text-semantic-global-text-default" data-e2e="offer-price">
            <Price currency={currency} dataAttr={endToEndPriceAttr} price={offerPrice} />
          </div>
        </div>
      ) : (
        <div className="typography-body-md-regular text-semantic-global-text-default" data-e2e="price">
          <Price currency={currency} dataAttr={endToEndPriceAttr} price={price} />
        </div>
      )}
    </div>
  )
}

export default PriceItem
